export default class NavigationService {
    static navigate = (routePath: string, routeName: string): boolean => {
        const {
            location,
            history,
        } = window

        // smooth scroll to top if same route
        if (location.pathname === routePath) {
            window.scrollTo({ top: 0, behavior: 'smooth' })
        }

        // change route only if there are different
        if (location.pathname !== routePath) {
            window.scrollTo({top: 0})

            // push new route in history
            history.pushState({}, routeName, routePath)

            // update location hash to update page
            location.hash = routePath

            // go back in history to get clean url
            history.back()

            window.dispatchEvent(new Event("location change"))
            return true;
        }

        return false;
    }
}
